<template>
  <v-container class="background-color: transparent">
    <v-row align="start" justify="center">
      <v-col cols="12" sm="12" md="6" xl="4">
        <p class="display-3 text-center">COPY TRADE</p>
        <v-spacer></v-spacer>
        <v-divider />

        <v-card flat class="background-color: transparent">
          <v-card-title class="headline">
            <v-icon large color="primary" class="mr-5">flip_to_front</v-icon>Copy Trade & Account Management
          </v-card-title>
          <v-card-text>
            TradingIF suppors:
            <v-list color="grey lighten-3">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Investor copy Investors</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Trader copy other Traders</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Copy between your accounts</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Indipendent Strategy for each investor's account</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="4">
        <v-img
          :min-height="'calc(50vh - ' + $vuetify.application.top + 'px)'"
          src="@/assets/bluetheme/Copy.png"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ChartSetup",
  data() {
    return {};
  },
  methods: {
    flatformPath(item) {
      return require("@/assets/platforms/logos/" + item.logo);
    }
  }
};
</script>

<style>
</style>
